<template>
  <div class="relative">

    <div class="vx-navbar-wrapper" :class="classObj">

      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">

        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar"/>

        <!--        <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" />-->

        <vs-spacer/>

        <!--        <search-bar />-->

        <!--        <notification-drop-down />-->

        <feather-icon v-if="unReadMessages.length" @click="$router.push('/messages')" icon="MailIcon"
                      class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="unReadMessages.length"/>
        <feather-icon v-else @click="$router.push('/received_messages')" icon="MailIcon"
                      class="cursor-pointer mt-1 sm:mr-6 mr-2"/>

        <profile-drop-down/>

      </vs-navbar>
    </div>
    <vs-popup :title="`${unReadMessages.length} پیام جدید `" class="send-message"
              :active.sync="unReadMessagesPopupVisible">
      <div>
        <message-card :key="message.id" v-for="message in unReadMessages" :message="message"></message-card>
      </div>
      <vs-button type="border" @click="unReadMessagesPopupVisible=false;$router.push('/received_messages')" class="mt-5">مشاهده همه
        پیام ها
      </vs-button>
    </vs-popup>
  </div>
</template>


<script>
  import Bookmarks from "./components/Bookmarks.vue"
  import SearchBar from "./components/SearchBar.vue"
  import NotificationDropDown from "./components/NotificationDropDown.vue"
  import ProfileDropDown from "./components/ProfileDropDown.vue"
  import MessageCard from "../../../views/messages/components/MessageCard";

  export default {
    name: "the-navbar-vertical",
    props: {
      navbarColor: {
        type: String,
        default: "#fff",
      },
    },
    data() {
      return {
        unReadMessagesPopupVisible: false
      }
    },
    watch:{
      unReadMessages(messages){
        this.unReadMessagesPopupVisible = !!messages.length;
      }
    },
    components: {
      MessageCard,
      Bookmarks,
      SearchBar,
      NotificationDropDown,
      ProfileDropDown,
    },
    mounted() {
      this.$http.post('message/retreive', {
        requester: this.$store.getters.userCredentials,
        request: {"count": 20, "page": 0}
      }).then(res => {
        let messages = res.data.msgs.filter(i => !i.readTime)
        this.$store.commit('UNREAD_MESSAGES_CHANGED', messages)
        if (messages.length)
          this.unReadMessagesPopupVisible = true
      })

    },
    computed: {
      navbarColorLocal() {
        return this.$store.state.theme === "dark" && this.navbarColor === "#fff" ? "#10163a" : this.navbarColor
      },
      verticalNavMenuWidth() {
        return this.$store.state.verticalNavMenuWidth
      },
      textColor() {
        return {'text-white': (this.navbarColor != '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor != '#fff' && this.$store.state.theme !== 'dark')}
      },
      windowWidth() {
        return this.$store.state.windowWidth
      },
      // NAVBAR STYLE
      classObj() {
        if (this.verticalNavMenuWidth == "default") return "navbar-default"
        else if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced"
        else if (this.verticalNavMenuWidth) return "navbar-full"
      },
      unReadMessages() {
        return this.$store.state.unReadMessages
      }
    },
    methods: {
      showSidebar() {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
      }
    }
  }
</script>

